/* eslint-disable */

import { Operator } from '../FbbEnum';
import { Coverage } from '../Coverage';

import { AddOnRouter } from './AddOnRouter';
import { AddOnRentalRouter } from './AddOnRentalRouter';
import { AddOnRentalRouterFree } from './AddOnRentalRouterFree';
import { AddOnNortonVPN } from './AddOnNortonVPN';
import { AddOnAppleiPad } from './AddOnAppleiPad';
import { AddOnRentalRouterShort } from './AddOnRentalRouterShort';
import { AddOnNoRouter } from './AddOnNoRouter';
import { AddOnBuyMeshRouter } from './AddOnBuyMeshRouter';
import { AddOnRentalMeshRouter } from './AddOnRentalMeshRouter';

import { AddOn } from './AddOn';
import { Config } from '../../../data/Config';
import * as log from '../../../common/js/appLogger';
import { AddOnParentControl } from './AddonParentControl';

//This is a special class that originally wanna put the methods to AddOn Class. But doing so the app will not able to run normally.
//If you have solution pls feel free to update.
export class AddOnUtil {
	static getLandingAddOnList(json: any): Array<AddOn> {
		var list: Array<AddOn> = [];
		//list.push(new AddOnRouter())
		if (Config.supportIPad) {
			list.push(new AddOnAppleiPad());
		}
		list.push(new AddOnRentalRouter());
		list.push(new AddOnRentalMeshRouter());
		list.push(new AddOnNortonVPN());

		for (var addon of list) {
			var j = AddOnUtil.findJson(json, addon.getKey());
			addon.parseConfig(j);
		}

		return list;
	}

	static getLandingAddOnListV2(json: any): Array<AddOn> {
		log.i('[getLandingAddOnListV2] get all possible addon service');

		var list: Array<AddOn> = [];
		list.push(new AddOnRouter());
		list.push(new AddOnRentalRouter());

		list.push(new AddOnBuyMeshRouter());
		list.push(new AddOnRentalMeshRouter());

		list.push(new AddOnNoRouter());
		list.push(new AddOnRentalRouterFree());

		list.push(new AddOnNoRouter());
		list.push(new AddOnNortonVPN());

		list.push(new AddOnParentControl());

		if (Config.supportIPad) {
			list.push(new AddOnAppleiPad());
		}

		for (var addon of list) {
			var j = AddOnUtil.findJson(json, addon.getKey());
			addon.parseConfig(j);
		}

		return list;
	}

	static findJson(jsonArray: any, key: string): any {
		var landing = jsonArray['landing'] ?? [];
		//log.ot('findJson', landing)
		for (var anAddonJson of landing) {
			//log.it('findJson', anAddonJson['id'])
			if ((anAddonJson['id'] ?? '_') === key) {
				return anAddonJson;
			}
		}
		return null;
	}

	// json: addonV2.json
	// addOnArr: current addon allowed
	static getConfigAddOnList(json: any, addOnAr: Array<AddOn>): Array<AddOn> {
		var list: Array<AddOn> = addOnAr;
		for (var addon of list) {
			var j = AddOnUtil.findJson(json, addon.getKey());
			addon.parseConfig(j);
		}

		return list;
	}

	//
	static getAddOnList(
		operator: Operator,
		tech: String,
		hkbnCov: Coverage,
		contractMonth: number,
		planCode: String,
		customerType: String = 'NSMC'
	): Array<AddOn> {
		log.i('getAddOnList');
		log.it('operator', operator);
		//log.i('getAddOnList|hkbnCov='+ hkbnCov.toString() + '|contractMonth=' + contractMonth );
		log.i('customerType=' + customerType + 'planCode' + planCode);
		let specialPlanCodeList = ['5g_hbb_Free3mths', '5g_hbb_Free3mths_12mth']; // only show router option(s)
		let freeRentalRouter = ['5g_hbb_Free3mths']; // show special rental router option: free 3-mth and need 1500 deposit
		let freeRentalRouterByRebate = [
			'5g_hbb_stu_GRWTH',
			'5g_hbb_stu_6m',
			'5g_hbb_6m',
			'5g_hbb_SIA_6m',
			'5g_hbb_SCHOOL_6m',
			'5g_hbb_SIA_12m',
			'5g_hbb_SCHOOL_12m',
		];
		let isSpecialPlan = specialPlanCodeList.indexOf(planCode.toString()) > -1;
		let isFreeRentalRouter = freeRentalRouter.indexOf(planCode.toString()) > -1;
		// 2022-01-19: show AddOnRentalRouterRebate instead of general rental router
		let isFreeRentalRouterByRebate = freeRentalRouterByRebate.indexOf(planCode.toString()) > -1;

		var list: Array<AddOn> = [];

		if (isSpecialPlan) {
			if (isFreeRentalRouter) {
				// 3-mth contract: no "buy router" option also
				list.push(new AddOnRentalRouterFree());
			} else {
				list.push(new AddOnRouter());
				list.push(new AddOnRentalRouter());
			}
		} else {
			list.push(new AddOnRouter());
			if (isFreeRentalRouterByRebate) {
				list.push(new AddOnRentalRouterShort());
			} else {
				list.push(new AddOnRentalRouter());
			}

			if (contractMonth == 24) {
				list.push(new AddOnNortonVPN());
			}

			if (Config.supportIPad) {
				list.push(new AddOnAppleiPad());
			}
		}

		return list;
	}

	// no return router add on
	static getOtherAddOnKeyListV2(contractMonth: number, planCode: String): Array<String> {
		log.i('[getAddOnKeyListV2] planCode=' + planCode + '|contractMonth=' + contractMonth);
		var list: Array<String> = [];

		let specialPlanCodeList = ['5g_hbb_Free3mths', '5g_hbb_Free3mths_12mth']; // only show router option(s)
		let freeRentalRouter = ['5g_hbb_Free3mths']; // show special rental router option: free 3-mth and need 1500 deposit
		let freeRentalRouterByRebate = [
			'5g_hbb_stu_GRWTH',
			'5g_hbb_stu_6m',
			'5g_hbb_6m',
			'5g_hbb_SIA_6m',
			'5g_hbb_SCHOOL_6m',
			'5g_hbb_SIA_12m',
			'5g_hbb_SCHOOL_12m',
		];
		let isSpecialPlan = specialPlanCodeList.indexOf(planCode.toString()) > -1;
		let isFreeRentalRouter = freeRentalRouter.indexOf(planCode.toString()) > -1;
		// 2022-01-19: show AddOnRentalRouterRebate instead of general rental router
		let isFreeRentalRouterByRebate = freeRentalRouterByRebate.indexOf(planCode.toString()) > -1;

		if (['5g_hbb_Free3mths', '5g_hbb_Free3mths_12mth'].indexOf(planCode.toString()) > -1) {
			// no norton and ipad
		} else {
			if (contractMonth == 24) {
				list.push('AddOnNortonVPN');
			}

			if (Config.supportIPad) {
				list.push('AddOnAppleiPad');
			}
		}
		return list;
	}

	static getAddOAddOnListV2(contractMonth: number, planCode: String): Array<AddOn> {
		log.i('[getAddOAddOnListV2] planCode=' + planCode + '|contractMonth=' + contractMonth);
		let specialPlanCodeList = ['5g_hbb_Free3mths', '5g_hbb_Free3mths_12mth']; // only show router option(s)
		let freeRentalRouter = ['5g_hbb_Free3mths']; // show special rental router option: free 3-mth and need 1500 deposit
		let freeRentalRouterByRebate = [
			'5g_hbb_stu_GRWTH',
			'5g_hbb_stu_6m',
			'5g_hbb_SIA_6m',
			'5g_hbb_SCHOOL_6m',
			'5g_hbb_SIA_12m',
			'5g_hbb_SCHOOL_12m',
		];
		// remove  "5g_hbb_6m" in freeRentalRouterByRebate list -> change to use AddOnRentalRouter
		let isSpecialPlan = specialPlanCodeList.indexOf(planCode.toString()) > -1;
		let isFreeRentalRouter = freeRentalRouter.indexOf(planCode.toString()) > -1;
		// 2022-01-19: show AddOnRentalRouterRebate instead of general rental router
		let isFreeRentalRouterByRebate = freeRentalRouterByRebate.indexOf(planCode.toString()) > -1;
		var list: Array<AddOn> = [];

		if (isSpecialPlan) {
			if (isFreeRentalRouter) {
				// 3-mth contract: no "buy router" option also
				list.push(new AddOnRentalRouterFree());
			} else {
				list.push(new AddOnRouter());
				list.push(new AddOnRentalRouter());
			}
		} else {
			list.push(new AddOnRouter());
			if (isFreeRentalRouterByRebate) {
				list.push(new AddOnRentalRouterShort());
			} else {
				list.push(new AddOnRentalRouter());
			}

			if (contractMonth == 24) {
				list.push(new AddOnNortonVPN());
			}

			if (Config.supportIPad) {
				list.push(new AddOnAppleiPad());
			}
		}

		return list;
	}
}
